const converter = {};

/**
 * 横書きのテキストを縦書きに変換
 * @param {*} text 文字列
 * @param {*} option　オプション
 */
converter.convert = (text, option) => {
  //変換テーブル
  const replaceTarget = [["ー", "｜"]];

  /**
   * 変換対象の文字だったら変換する
   * @param {*} char 文字
   * @returns 変換後の文字
   */
  const replaceChar = (char) => {
    const replaced = replaceTarget.filter((target) => char === target[0]);
    if (replaced.length > 0) {
      return replaced[0][1];
    }
    return char;
  };

  /**
   * 文字列から指定の文字列で始まる行を抽出
   * @param {*} strList 文字列の配列
   * @param {*} condition 抽出条件
   */
  const extractText = (strList, condition) => {
    return strList.filter((str) => str.indexOf(condition) === 0);
  };

  /**
   * 文字列を行ごとに分割して配列化
   * @param {*} strList 文字列を格納した配列
   */
  const splitText = (strList) => {
    const charList = [];
    strList.forEach((str) => {
      charList.push([...str]);
    });
    return charList;
  };

  /**
   * 最も文字数が多い行の文字数を取得
   * @param {*} charList 文字列リスト
   * @returns 最大文字数
   */
  const getMaxLength = (charList) => {
    let maxLength = 0;
    charList.forEach((chars) => {
      maxLength = maxLength < chars.length ? chars.length : maxLength;
    });
    return maxLength;
  };

  /**
   * 文字が半角かどうか判定
   * @param {*} char 文字
   * @returns 半角ならtrue
   */
  const isHalfChar = (char) => {
    return !char.match(/[^\x01-\x7E]/) || !char.match(/[^\uFF65-\uFF9F]/);
  };

  if (!text) {
    return "";
  }
  // 文字列を1行ずつ分割
  const rawStrList = text.split(/\n/);
  // #から始まる行を取り出す
  const hashTagList = extractText(rawStrList, "#");
  // URL(http://、https://)から始まる行を取り出す
  const urlList = extractText(rawStrList, "http://").concat(
    extractText(rawStrList, "https://")
  );
  // 上記の条件に合致した行を元の配列から除外
  let strList = rawStrList.filter(
    (str) => !hashTagList.includes(str) && !urlList.includes(str)
  );
  // 最終行が空行だったらその行を削除
  if (strList.length > 0) {
    while (strList[strList.length - 1] === "") {
      strList.pop();
    }
  }

  // 各行の文字列を1文字ずつ分割して配列化
  const charList = splitText(strList);

  const verticalStrList = [];

  const maxLength = getMaxLength(charList);
  [...Array(maxLength)].map((_, i) => {
    const tempCharList = [];
    charList.forEach((chars) => {
      if (chars.length > i) {
        const char = replaceChar(chars[i]);
        tempCharList.unshift(isHalfChar(char) ? " " + char : char);
      } else {
        tempCharList.unshift("　");
      }
    });
    verticalStrList.push(tempCharList);
  });
  let verticalStr = "";
  verticalStrList.forEach((str) => {
    verticalStr += `${str.join("")}\n`;
  });
  if (hashTagList.length > 0 || urlList.length > 0) {
    verticalStr += "\n";
    hashTagList.forEach((str) => {
      verticalStr += `${str}\n`;
    });
    urlList.forEach((str) => {
      verticalStr += `${str}\n`;
    });
  }
  return verticalStr;
};

export default converter;
